import React from "react";
import styled from "styled-components";
import Icon from "./Icon";
import { Colors } from "../../config";

const SidebarItems = ({ onClick, path, labeltext, isActive }) => {
  return (
    <Wrapper onClick={onClick}>
      <SidebarItem isActive={isActive}>
        <Icon path={path} isActivePath={isActive} />
        <Label isActive={isActive}>{labeltext}</Label>
      </SidebarItem>
    </Wrapper>
  );
};

export default SidebarItems;

const Wrapper = styled.div`
  margin: 1.625rem 0rem;
`;
export const SidebarItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;
const Label = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
  color: ${(props) => (props.isActive ? Colors.brandTwo : Colors.white)};
`;
